export const editOrderNotificationsReceivers = {
    provider: "provider",
    company: "company"
};

export const editOrderNotificationsOption = [
    {label: "שליחת מייל עדכון + סמס לספק", value: editOrderNotificationsReceivers.provider},
    {label: "שליחת מייל עדכון לחברה", value: editOrderNotificationsReceivers.company}
];
